import { styled, css } from 'styled-components';
import { createTransition } from '../../../util';
import { HelperTextWrapper } from './TextareaHelperText';
const textAreaInputStatus = status => css(["box-shadow:inset 0 0 0 0.0625rem var(--aui-status-", ");&:focus-within,&:active{box-shadow:inset 0 0 0 0.125rem var(--aui-status-", ");}"], status, status);
const inputStateToCss = {
  success: textAreaInputStatus('success'),
  warn: textAreaInputStatus('warning'),
  error: textAreaInputStatus('error'),
  default: css(["box-shadow:inset 0 0 0 0.0625rem var(--aui-outline);&:hover ~ ", ",&active ~ ", ",&:focus-within ~ ", "{color:var(--aui-on-surface);}&:hover{box-shadow:inset 0 0 0 0.0625rem var(--aui-on-surface);}&:focus-within,&:active{box-shadow:inset 0 0 0 0.125rem var(--aui-on-surface);}"], HelperTextWrapper, HelperTextWrapper, HelperTextWrapper)
};
export const TextareaContainer = styled.div.withConfig({
  componentId: "aui__sc-58id5b-0"
})(["position:relative;display:flex;flex-direction:column;border-radius:0.5rem;box-sizing:border-box;background-color:var(--aui-surface);", " padding-bottom:3px;cursor:text;", ""], createTransition({
  properties: ['box-shadow']
}), ({
  $fieldStatus,
  $disabled
}) => $disabled ? css(["background-color:var(--aui-neutral-soft);box-shadow:inset 0 0 0 0.0625rem var(--aui-outline);cursor:not-allowed;& ~ ", "{color:var(--aui-on-surface-soft);opacity:var(--aui-state-layer-on-disabled);}"], HelperTextWrapper) : inputStateToCss[$fieldStatus]);